import { combineReducers, configureStore } from '@reduxjs/toolkit';

// middlewares
import thunkMiddleware from 'redux-thunk';
// import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import { all } from 'redux-saga/effects';
import { persistStore } from 'redux-persist';

import persistReducers from './persistReducer';

// Import custom reducers and sagas:
import sidebar from './modules/sidebar';
import users, { usersSaga } from './modules/users';
import session, { sessionSaga } from './modules/session';
import clients, { clientsSaga } from './modules/clients';
import bases, { basesSaga } from './modules/bases';
import ordersBtc, { ordersBtcSaga } from './modules/ordersBtc';
import ordersBtb, { ordersBtbSaga } from './modules/ordersBtb';
import companies, { companiesSaga } from './modules/companies';
import plans, { plansSaga } from './modules/plans';
import subscriptions, { subscriptionsSaga } from './modules/subscriptions';
import purchases, { purchasesSaga } from './modules/purchases';
import invoices, { invoicesSaga } from './modules/invoices';
import coupons, { couponsSaga } from './modules/coupons';
import credits, { creditsSaga } from './modules/credits';

function saveToLocalStorage(state) {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem('state', serializedState);
	} catch (e) {
		return undefined;
	}
}

let store;
let persistor;

if (!store) {
	const sagaMiddleware = createSagaMiddleware();

	const reducers = combineReducers({
		sidebar,
		session,
		users,
		clients,
		bases,
		ordersBtc,
		ordersBtb,
		companies,
		plans,
		subscriptions,
		purchases,
		invoices,
		coupons,
		credits,
	});

	store = configureStore({
		reducer: persistReducers(reducers),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({ serializableCheck: false })
				.concat(thunkMiddleware)
				.concat(sagaMiddleware),
		devTools: process.env.REACT_APP_ENVIRONMENT !== 'production',
	});

	persistor = persistStore(store);

	const rootSaga = function* () {
		yield all([
			sessionSaga(),
			usersSaga(),
			clientsSaga(),
			basesSaga(),
			ordersBtcSaga(),
			ordersBtbSaga(),
			companiesSaga(),
			plansSaga(),
			subscriptionsSaga(),
			purchasesSaga(),
			invoicesSaga(),
			couponsSaga(),
			creditsSaga(),
			// ... other sagas
		]);
	};

	sagaMiddleware.run(rootSaga);

	const unsubscribe = store.subscribe(() => {
		const state = store.getState();
		saveToLocalStorage(state);
	});
}

export { store, persistor };
